var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.cplist),function(item,index){return _c('van-card',{key:item.name,attrs:{"tag":"品质精选","desc":_vm.htmlToString(_vm.escape2Html(item.desc)),"title":item.name,"thumb":item.mainpic[0],"placeholder":true},on:{"click":function($event){return _vm.todetail(index)}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c5162b3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/cplist/index.vue
// module id = null
// module chunks = 